"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _Field = _interopRequireDefault(require("./Field"));

var _validatorjs = _interopRequireDefault(require("validatorjs"));

var _FormRow = _interopRequireDefault(require("./FormRow"));

var _lodash = require("lodash");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/**
 * Form is a component which allows you to create a managed or self-managed form.
 *
 */


var Form =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Form, _React$Component);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Form).call(this, props));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "state", {
      fields: [],
      fieldOrder: [],
      value: {},
      errors: {}
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderField", function (name) {
      var fields = _this.state.fields;
      var field = fields[name];

      if (!field) {
        return null;
      }

      var _this$props = _this.props,
          onValidate = _this$props.onValidate,
          onChange = _this$props.onChange,
          variant = _this$props.variant;

      var _ref = onValidate ? _this.props : _this.state,
          _ref$errors = _ref.errors,
          errors = _ref$errors === void 0 ? {} : _ref$errors;

      var _ref2 = onChange ? _this.props : _this.state,
          value = _ref2.value;

      var render = field.render,
          type = field.type,
          fieldProps = _objectWithoutProperties(field, ["render", "type"]);

      var fieldValue = value ? (0, _lodash.get)(value, name) : undefined;
      var fieldErrors = errors[name];
      var children = render ? render(fieldValue, function (val, e) {
        return _this.handleFieldChange(name, val, e);
      }) : undefined;
      return React.createElement(_Field.default, _extends({
        key: name,
        name: name,
        type: type,
        variant: variant,
        children: children
      }, fieldProps, {
        errors: fieldErrors,
        value: fieldValue,
        onChange: function onChange(val, e) {
          return _this.handleFieldChange(name, val, e);
        },
        onBlur: function onBlur(e) {
          return _this.handleValidation(_this.getValue(), name, 'blur');
        }
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "renderRow", function (row, index) {
      return React.createElement(_FormRow.default, {
        key: index
      }, (0, _lodash.map)(row, function (name) {
        return _this.renderField(name);
      }));
    });

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleSubmit", function (e) {
      e.preventDefault();

      var value = _this.getValue();

      var ok = _this.handleValidation(value, undefined, 'submit');

      ok && _this.props.onSubmit && _this.props.onSubmit(value);
    });

    if (!props.onChange) {
      // IF the form is internally managed, initialise fields to empty strings to
      // prevent warning about unmanaged fields becoming managed
      var names = (0, _lodash.map)(props.fields, function (value, name) {
        return value.name || name;
      });
      _this.state.value = (0, _lodash.reduce)(names, function (result, name) {
        result[name] = '';
        return result;
      }, {});
    }

    return _this;
  }

  _createClass(Form, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.orderFields(this.props.fields, this.props.layout);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(props) {
      this.orderFields(props.fields, props.layout);
    }
  }, {
    key: "orderFields",
    value: function orderFields() {
      var fields = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var layout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var fieldsObj = fields;

      if ((0, _lodash.isArray)(fields)) {
        fieldsObj = (0, _lodash.reduce)(fields, function (result, field) {
          return _extends({}, result, _defineProperty({}, field.name, field));
        }, {});
      } else {
        fieldsObj = (0, _lodash.mapValues)(fields, function (value, name) {
          return _extends({}, value, {
            name: name
          });
        });
      }

      var normalisedLayout = (0, _lodash.map)(layout, function (row) {
        return (0, _lodash.isArray)(row) ? row : [row];
      });
      var missingFields = (0, _lodash.difference)((0, _lodash.keys)(fieldsObj), (0, _lodash.flatten)(normalisedLayout));

      var fieldOrder = _toConsumableArray(normalisedLayout).concat(_toConsumableArray((0, _lodash.map)(missingFields, function (field) {
        return [field];
      })));

      this.setState({
        fields: fieldsObj,
        fieldOrder: fieldOrder
      });
    }
  }, {
    key: "getValue",
    value: function getValue() {
      var onChange = this.props.onChange;

      var _ref3 = onChange ? this.props : this.state,
          _ref3$value = _ref3.value,
          value = _ref3$value === void 0 ? {} : _ref3$value;

      return value;
    }
  }, {
    key: "hasValidateOn",
    value: function hasValidateOn(validateOn, actionType) {
      return validateOn.indexOf(actionType) >= 0;
    }
  }, {
    key: "shouldValidate",
    value: function shouldValidate(currentField, actionType, fieldName) {
      var _find = (0, _lodash.find)(this.state.fields, {
        name: fieldName
      }),
          _find$validateOn = _find.validateOn,
          validateOn = _find$validateOn === void 0 ? 'blur,submit' : _find$validateOn; // always validate when 'always' set


      if (this.hasValidateOn(validateOn, 'always')) {
        return true;
      } // validate if its the current field and the actionType is matched or if we're
      // submitting


      if (fieldName === currentField || actionType === 'submit') {
        return this.hasValidateOn(validateOn, actionType);
      } // if validateOn contains the current field, update


      if (currentField && this.hasValidateOn(validateOn, currentField)) {
        return true;
      }
    }
  }, {
    key: "handleValidation",
    value: function handleValidation(data, fieldName, type) {
      var _this2 = this;

      var _this$state$fields = this.state.fields,
          fields = _this$state$fields === void 0 ? {} : _this$state$fields;
      var fieldsObj = fields;
      var rules = (0, _lodash.chain)(fieldsObj).mapValues(function (field) {
        return field.validation;
      }).pickBy(function (rule, name) {
        return rule;
      }).pickBy(function (rule, name) {
        return _this2.shouldValidate(fieldName, type, name);
      }).value();

      if ((0, _lodash.isEmpty)(rules)) {
        return true;
      }

      var messages = (0, _lodash.reduce)(fieldsObj, function (result, field, name) {
        return _extends({}, result, (0, _lodash.reduce)(field.errors, function (r, message, error) {
          return _extends({}, r, _defineProperty({}, "".concat(error, ".").concat(name), message));
        }, {}));
      }, {});
      var validation = new _validatorjs.default(data, rules, messages); // Run the validation

      validation.fails();
      var errors = (0, _lodash.mapValues)(rules, function (value, name) {
        return validation.errors.get(name) || [];
      });
      var onValidate = this.props.onValidate;

      if (onValidate) {
        return onValidate(errors);
      } else {
        this.setState({
          errors: _extends({}, this.state.errors, errors)
        });
        console.log('Errors ', errors);
        return !(0, _lodash.some)(errors, function (value) {
          return value.length;
        });
      }
    }
  }, {
    key: "handleFieldChange",
    value: function handleFieldChange(field, value, e) {
      // checkboxes don't use value - they use 'checked' because FU react.
      var newValue = (0, _lodash.cloneDeep)(this.getValue());
      (0, _lodash.set)(newValue, field, value);
      this.handleValidation(newValue, field, 'change');
      var onChange = this.props.onChange;

      if (onChange) {
        onChange(newValue, e);
      } else {
        this.setState({
          value: newValue
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props2 = this.props,
          _this$props2$classNam = _this$props2.className,
          className = _this$props2$classNam === void 0 ? '' : _this$props2$classNam,
          children = _this$props2.children,
          errors = _this$props2.errors,
          value = _this$props2.value,
          onValidate = _this$props2.onValidate,
          onChange = _this$props2.onChange,
          as = _this$props2.as,
          props = _objectWithoutProperties(_this$props2, ["className", "children", "errors", "value", "onValidate", "onChange", "as"]);

      var fieldOrder = this.state.fieldOrder;
      var As = as || "form";
      return React.createElement(As, _extends({
        noValidate: true
      }, (0, _lodash.omit)(props, ['fields']), {
        className: "Form ".concat(className),
        onSubmit: this.handleSubmit
      }), (0, _lodash.map)(fieldOrder, function (row, index) {
        return _this3.renderRow(row, index);
      }), children);
    }
  }]);

  return Form;
}(React.Component);

var _default = Form;
exports.default = _default;